import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * Staggered fade-up reveal for the services ledger rows.
 * Rows stay visible when the animation is off, in the theme editor,
 * or when the visitor prefers reduced motion.
 */
class ServicesLedgerComponent extends Component {
  #observer;

  connectedCallback() {
    super.connectedCallback();

    if (!this.hasAttribute('data-reveal') || prefersReducedMotion() || window.Shopify?.designMode) return;

    [...this.children].forEach((child, index) => {
      child.style.setProperty('--services-ledger-order', index);
    });

    this.setAttribute('data-reveal-armed', '');

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.setAttribute('data-revealed', '');
        this.#observer?.disconnect();
      },
      { rootMargin: '0px 0px -15% 0px' }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }
}

if (!customElements.get('services-ledger-component')) {
  customElements.define('services-ledger-component', ServicesLedgerComponent);
}
